// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var DateCondition$ReactHooksTemplate = require("./DateCondition.res.js");

function DateConditionForm(props) {
  var updateCondition = props.updateCondition;
  var dateCondition = props.dateCondition;
  var operator = DateCondition$ReactHooksTemplate.operator(dateCondition);
  var rhs = DateCondition$ReactHooksTemplate.rhs(dateCondition);
  var availableOperators = DateCondition$ReactHooksTemplate.availableOperators();
  var handleOperatorChange = function ($$event) {
    var selectedOperator = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updatedDateCondition = DateCondition$ReactHooksTemplate.setOperator(dateCondition, selectedOperator);
    Curry._1(updateCondition, {
          TAG: "DateCondition",
          _0: updatedDateCondition
        });
  };
  var handleRhsChange = function ($$event) {
    var inputValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updatedDateCondition = DateCondition$ReactHooksTemplate.setRhs(dateCondition, inputValue);
    Curry._1(updateCondition, {
          TAG: "DateCondition",
          _0: updatedDateCondition
        });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Condition",
                              className: "w-48-px h-20-px font-normal text-xs text-aurometalsaurus "
                            }),
                        JsxRuntime.jsx("select", {
                              children: $$Array.of_list(Belt_List.map(availableOperators, (function (operator) {
                                          return JsxRuntime.jsx("option", {
                                                      children: DateCondition$ReactHooksTemplate.humanizeOperator(operator),
                                                      className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300",
                                                      value: operator
                                                    }, operator);
                                        }))),
                              className: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                   cursor-pointer focus:border-gray-600 text-xs",
                              placeholder: "Select Operator",
                              value: operator,
                              onChange: handleOperatorChange
                            })
                      ],
                      className: "flex flex-col w-6/12"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Answer",
                              className: "h-20-px font-normal text-xs text-aurometalsaurus "
                            }),
                        JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                              label: "Answer",
                              value: rhs,
                              handleChange: handleRhsChange,
                              placeholder: "Enter Answer",
                              textInputClassName: "h-40-px px-2 py-1 rounded bg-white border border-gray-300\n                            cursor-pointer focus:border-gray-600 text-xs w-full",
                              inputBoxContainerCss: "flex flex-col w-full"
                            })
                      ],
                      className: "flex flex-col w-8/12"
                    })
              ],
              className: "flex gap-2 w-full"
            });
}

var make = DateConditionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
